import { FC, useState } from 'react';
import {
  IconButton,
  ListItemText,
  MenuItem,
  Popover,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { txt: 'English', val: 'en' },
  { txt: 'Nederlands', val: 'nl' },
  { txt: 'Deutsch', val: 'de' },
  { txt: 'Español', val: 'es' },
  { txt: 'Italiano', val: 'it' },
  { txt: 'Français', val: 'fr' },
  { txt: 'Português', val: 'pt' },
];

export const LanguageSwitcher: FC = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >();
  const currentLng = (i18n.resolvedLanguage || i18n.language || 'en').slice(
    0,
    2
  );

  const closeMenuHandler = () => setAnchorEl(null);
  const openMenuHandler = ({
    currentTarget,
  }: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
    setAnchorEl(currentTarget);

  const open = Boolean(anchorEl);
  const id = open ? 'choose language' : undefined;

  const languageChangeHandler = (lng: string) => {
    i18n.changeLanguage(lng);
    closeMenuHandler();
  };

  return (
    <>
      {/* Same size as the other chrome icon buttons; shows the code, not a flag. */}
      <Tooltip title={t('language') as string}>
        <IconButton
          size="small"
          aria-label={t('changeLanguage') as string}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={openMenuHandler}
          sx={{ width: 34, height: 34 }}
        >
          <Typography
            component="span"
            textTransform="uppercase"
            fontSize={12}
            fontWeight={600}
            letterSpacing="0.04em"
            lineHeight={1}
            color="languageLabel"
          >
            {currentLng}
          </Typography>
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={closeMenuHandler}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            backgroundColor: 'customGrey.light',
            borderTopRightRadius: 0,
            py: 2,
          },
        }}
      >
        {LANGS.map(({ txt, val }, index) => {
          const isSelected = currentLng === val;
          return (
            <MenuItem
              key={index}
              selected={isSelected}
              onClick={() => languageChangeHandler(val)}
            >
              <ListItemText>
                <Typography
                  align="center"
                  fontSize={14}
                  color={isSelected ? 'primary' : undefined}
                >
                  {txt}
                </Typography>
              </ListItemText>
            </MenuItem>
          );
        })}
      </Popover>
    </>
  );
};
